import { clipboardWrite } from '../../../../utils/text/clipboard';
import { WithTooltip } from '../../../core/WithTooltip';
import { LeadingIcon } from '../../../core/svgicons';

import useStyles from './linkButtonStyles';
import { LinkButtonProps } from './types';

export function LinkButton({ copyShareDisabled, data, onLinkButtonClick }: LinkButtonProps) {
  const classes = useStyles();
  const onClick = () => {
    onLinkButtonClick && onLinkButtonClick(data);
    clipboardWrite(data[0]);
  };
  const content = (
    <>
      Add to design <LeadingIcon className={classes.icon} />
    </>
  );

  return copyShareDisabled ? (
    <button type="button" className={classes.root} disabled={copyShareDisabled} onClick={onClick}>
      {content}
    </button>
  ) : (
    <WithTooltip
      text="Add your text on an image in our FREE Web Editor and start designing."
      position="up"
      className={classes.tooltip}
    >
      <button type="button" className={classes.root} onClick={onClick}>
        {content}
      </button>
    </WithTooltip>
  );
}
